import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { adjustServingsModalMatchFor } from 'config/paths';
import { Redirect } from 'components/Routing';
import { ScrollableFormModal } from 'components/Modal';
import FormikWrapper from 'components/FormikWrapper';
import * as Yup from 'yup';
import { RecipeMealServingToggle } from './MealAndRecipeSearch';
import MacroSummary from './MacroSummary';
import IngredientInfo from './IngredientInfo';

const AdjustServingsContent = ({ setServings, meal, match: { params: { recipeId } }, basePath, renderHeader, renderScrollable, renderFooter }) => {
    const recipeMeal = meal.recipeMealFor(Number(recipeId));
    const [servings,setLocalServings] = useState(recipeMeal && recipeMeal.servings);

    if(recipeMeal) {
        return (
            <React.Fragment>
                {renderHeader()}
                <FormikWrapper
                    initialValues={ { recipeId: recipeMeal.recipeId, servings: recipeMeal.readableServings() } }
                    submit={(values) => setServings({ recipeId: values.recipeId, servings: recipeMeal.actualServings(values.servings) })}
                    validationSchema={Yup.object().shape({
                        servings: Yup.number().moreThan(0).required()
                    })}
                    initialErrors={{}}
                    render={({ handleSubmit, submitState, values, setValues, errors, handleBlur }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                {renderScrollable({ children: (
                                    <div className="text-center">
                                        <div className="pt20 pb20 pl10 pr10">
                                            <RecipeMealServingToggle
                                                recipeMeal={recipeMeal}
                                                values={values}
                                                setValues={setValues}
                                                errors={errors}
                                                handleBlur={handleBlur}
                                                setServings={setLocalServings}
                                            />
                                            <div className="mt15 lh1">
                                                {recipeMeal.recipe.isFullyLoaded() && (
                                                    <div className="slight-emphasis-bcg pa20 text-center left-align-block font-grey">
                                                        <IngredientInfo recipeId={recipeMeal.recipeId} servings={servings} includeMacros />
                                                    </div>
                                                )}
                                                {!recipeMeal.recipe.isFullyLoaded() && (
                                                    <div className="text-center">
                                                        <MacroSummary macroHash={recipeMeal.recipe.macroHash(servings)} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )})}
                                {renderFooter({ loadState: submitState, disabled: !!errors.servings, id: 'save-servings-btn' })}
                            </form>
                        )


                    }}
                />
            </React.Fragment>
        )
    } else {
        return <Redirect to={basePath} />
    }

}

const AdjustServingsModal = ({ basePath, meal, setServings }) => {
    const { t } = useTranslation();
    return (
        <ScrollableFormModal
            fullWidth
            noOverflow
            limitWidth
            path={adjustServingsModalMatchFor(basePath)}
            exact
            icon={['far','edit']}
            title={t("Adjust Portions")}
            render={({ renderFooter, renderScrollable, renderHeader, match }) => (
                <AdjustServingsContent
                    meal={meal}
                    basePath={basePath}
                    match={match}
                    renderFooter={renderFooter}
                    renderScrollable={renderScrollable}
                    renderHeader={renderHeader}
                    setServings={setServings}
                />
            )}
        />
    )
}

export { AdjustServingsModal, AdjustServingsContent }
